// extracted by mini-css-extract-plugin
module.exports = {"menu":"instance-menu_menu__tuWCw","item":"instance-menu_item__FMLp_","delete":"instance-menu_delete__a94Ah"};